import axios from 'axios'
import QS from 'qs'
import { getCookie , delCookie , setCookie } from './util';// cookie操作
    // import router from '../routes'

axios.defaults.timeout = 5000; //请求超时5秒
axios.defaults.baseURL =''; //请求base url
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //设置post请求是的header信息
axios.defaults.withCredentials = true;   // 如果你要用到session验证码功能，让请求携带cookie
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
let instance = axios.create({
  headers: {'content-type':'multipart/form-data'}
});
//http request 拦截器
axios.interceptors.request.use(
  config => {
     if(process.env.VUE_APP_SHAREINFO_TOKEN == 1){  setCookie(
        "member_token",
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJxcXExMTEiLCJtZCI6ImluZGV4IiwiaWQiOjQsImp0aSI6InNXVDEwNnAxbW4waXR5aXAiLCJuYmYiOjE3MjczMzgxMTYsImV4cCI6MTcyNzM0NTMxNiwiaWF0IjoxNzI3MzM4MTE2LCJpc3MiOiJodHRwczpcL1wveHhzeS5jdGZ0Lm5ldFwvbWVtYmVyXC9sb2dpbiJ9.3avNgmbFxbj2h8tj4rvyrweqiGY3L0MLjO1LkAzy3Nc'
      );
   }
    const AUTH_TOKEN = getCookie('member_token');
    config.headers.developsign = '1fa4af77a26c7d33070ba4d7de148b78'
    if (AUTH_TOKEN) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = AUTH_TOKEN;
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
);
axios.interceptors.response.use(
  response => {
    return response
  },
  err => {
    return Promise.reject(err)
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = (url, params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
      params: params
    })
      .then(res => {
      if(res.data.code == 301 || res.data.code == 302){
         window.location.href = "/login/login.html?request_url="+encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
      }
      resolve(res.data)
    })
      .catch(err => {
      reject(err.data)
    })
  })
};
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = (url, ...params) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(...params))
      .then(res => {
      if(res.data.code == 301 || res.data.code == 302){
         window.location.href = "/login/login.html?request_url="+encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
      }
      resolve(res.data)
    })
      .catch(err => {
      reject(err.data)
    })
  })
};
/**
 * delet方法，对应delett请求
 * @param {String} url [请求的url地址]
 * delete关键字会和vue系统关键字冲突，所以这里用delet代替
 * delete用于删除，参数一般带在url
 */
export const delet = (url, params) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
      params: params
    })
      .then(res => {
      if(res.data.code == 301 || res.data.code == 302){
         window.location.href = "/login/login.html?request_url="+encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
      }
      resolve(res.data)
    })
      .catch(err => {
      reject(err.data)
    })
  })
};
/**
 * patch方法，对应patch请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 这里根据需求适应了formdata的格式，也可以跟post用一样的封装
 */
export const patch = (url, params) => {
  // 将数据转换为formData格式
  // 正常情况下可以直接使用参数对象进行patch，如果出错可以尝试转换form Data
  var formData = new FormData();
  formData.append('account', params.account);
  formData.append('password', params.password);
  return new Promise((resolve, reject) => {
    axios
      .patch(url, formData)
      .then(res => {
      if(res.data.code == 301 || res.data.code == 302){
         window.location.href = "/login/login.html?request_url="+encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
      }
      resolve(res.data)
    })
      .catch(err => {
      reject(err.data)
    })
  })
};
/**
 * 封装post请求 FormData方式
 * @param url
 * @param data
 * @returns {Promise}
 */
export const postform=(url,data = {})=>{
  return new Promise((resolve,reject) => {
    instance
      .post(url,data)
      .then(res => {
      if(res.data.code == 301 || res.data.code == 302){
         window.location.href = "/login/login.html?request_url="+encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
      }
      resolve(res.data);
    },err => {
      reject(err.data)
    })
  })
}

const http = {
   get: get,
   post: post,
   delet: delet,
   patch: patch,
   postform: postform,
};

export default http;
